// Module
var code = `<div class="announcement-location-map" id="announcement-location-map"></div> `;
// Exports
export default code;